<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/thankyou",
		    "name": "Thank You"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Thank You</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
      </div>
    </div>
  </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-12 desc section-pb section-pt">
            <p class="text-center fontsize24"> Our team will get in touch with you within 24 hrs.</p>
        </div>
    </div>
</div>
